import './root.scss';
import Info from '../../blocks/info/info';
import ProjectsAndSkills from '../../blocks/projectsAndSkills/projectsAndSkills';
import { ThemeContext, themes } from '../../contexts/themeContext';
import Toggle from '../toggle/toggle';

const Root = () => {
    return (
        <>
            <ThemeContext.Consumer>
                {({ theme, setTheme }) => (
                    <Toggle
                        onChange={() => {
                            if (theme === themes.light) setTheme(themes.dark)
                            if (theme === themes.dark) setTheme(themes.light)
                        }}
                        value={theme === themes.dark}
                    />
                )}
            </ThemeContext.Consumer>
            <Info />
            <ProjectsAndSkills />
        </>
    );
}

export default Root;
